import CopyFileDialog from './CopyFileDialog';

export default CopyFileDialog;
